<template>
    <div>
        <el-table
            :data="tableData"
            :summary-method="getSummaries"
            show-summary
        >
            <el-table-column
                prop="commitment_loan_statue"
                width="140"
                label="Commitment Type"
            >
                <template slot="header" slot-scope="scope">
                    <span class="text-break">{{ scope.column.label }}</span>
                </template>
                <div slot-scope="scope" v-if="scope.row.commitment_is_manual">
                    <el-select v-model="scope.row.commitment_loan_statue" :disabled="(_gHlp.checkAccess(['role_telemarketing']))"  >
                        <el-option
                        v-for="(item,index) in tables.loan_types"
                        :key="index"
                        :label="item.code === item.name ? item.code : `${item.code} - ${item.name}`"
                        :value="item.code">
                        </el-option>
                    </el-select>
                </div>
                <div v-else>
                    {{ scope.row.commitment_loan_statue }}
                </div>
            </el-table-column>
            <el-table-column
                prop="bank"
                width="130px"
                label="Bank"
            >
                <template slot-scope="scope">
                    <el-select v-model="scope.row.commitment_bank_id" v-if="scope.row.commitment_is_manual" :disabled="(_gHlp.checkAccess(['role_telemarketing']))" >
                        <el-option
                        v-for="item in tables.banks"
                        :key="item.bank_id"
                        :label="item.code"
                        :value="item.bank_id">
                        </el-option>
                    </el-select>
                    <div v-else>N/A</div>
                </template>
            </el-table-column>
            <el-table-column
                prop="commitment_credit_limit"
                sortable
                width="150px"
                :formatter="formatCurrency"
                label="Credit Limit"
            >
                <template slot-scope="scope">
                    <el-input v-model="scope.row.commitment_credit_limit" v-if="scope.row.commitment_is_manual" :disabled="(_gHlp.checkAccess(['role_telemarketing']))" ></el-input>
                    <div v-else>{{ scope.row.commitment_credit_limit }}</div>
                </template>
            </el-table-column>
            <el-table-column
                prop="commitment_current_outstanding"
                sortable
                width="170px"
                :formatter="formatCurrency"
                label="Current Outstanding"
            >
                <template slot="header" slot-scope="scope">
                    <span class="text-break">{{ scope.column.label }}</span>
                </template>
                <template slot-scope="scope">
                    <el-input v-model="scope.row.commitment_current_outstanding" v-if="scope.row.commitment_is_manual" :disabled="(_gHlp.checkAccess(['role_telemarketing']))" ></el-input>
                    <div v-else>{{ scope.row.commitment_current_outstanding }}</div>
                </template>
            </el-table-column>
            <el-table-column
                prop="commitment_current_installment"
                sortable
                width="160px"
                :formatter="formatCurrency"
                label="Current Instalment"
            >
                <template slot="header" slot-scope="scope">
                    <span class="text-break">{{ scope.column.label }}</span>
                </template>
                <template slot-scope="scope">
                    <el-input v-model="scope.row.commitment_current_installment" v-if="scope.row.commitment_is_manual" :disabled="(_gHlp.checkAccess(['role_telemarketing']))" ></el-input>
                    <div v-else>{{ scope.row.commitment_current_installment }}</div>
                </template>
            </el-table-column>
            <el-table-column
                prop="commitment_special_settlement"
                sortable
                width="160px"
                :formatter="formatCurrency"
                label="Special Settlement"
            >
                <template slot="header" slot-scope="scope">
                    <span class="text-break">{{ scope.column.label }}</span>
                </template>
                <template slot-scope="scope">
                    <el-input v-model="scope.row.commitment_special_settlement" :disabled="(_gHlp.checkAccess(['role_telemarketing']))" ></el-input>
                </template>
            </el-table-column>
            <el-table-column
                prop="commitment_consolidate_settlement"
                sortable
                width="180px"
                :formatter="formatCurrency"
                label="Consolidate Settlement"
            >
                <template slot="header" slot-scope="scope">
                    <span class="text-break">{{ scope.column.label }}</span>
                </template>
                <template slot-scope="scope">
                    <el-input v-model="scope.row.commitment_consolidate_settlement" :disabled="(_gHlp.checkAccess(['role_telemarketing']))" ></el-input>
                </template>
            </el-table-column>
            <el-table-column
                prop="commitment_new_installment"
                sortable
                width="180px"
                :formatter="formatCurrency"
                label="New Instalment"
            >
                <template slot="header" slot-scope="scope">
                    <span class="text-break">{{ scope.column.label }}</span>
                </template>
                <template slot-scope="scope">
                    <el-input v-model="scope.row.commitment_new_installment" :disabled="(_gHlp.checkAccess(['role_telemarketing']))" ></el-input>
                </template>
            </el-table-column>

						<!-- fullcontent -->
						<el-table-column
                prop="commitment_repay_term"
                width="120px"
                label="Prin. Rpmt. Term"
								v-if="isfull"
            >
                <template slot="header" slot-scope="scope">
                    <span class="text-break">{{ scope.column.label }}</span>
                </template>
                <template slot-scope="scope">
                    <!-- <el-input v-model="scope.row.commitment_repay_term"></el-input> -->
                    {{ scope.row.commitment_repay_term }}
                </template>
            </el-table-column>
						<el-table-column
                prop="commitment_monthly"
                label="Conduct of Acc for last 12 Months From"
								:width="60 *12"
								v-if="isfull"
            >
								
                <template slot-scope="scope">
									<div class="d-flex align-items-center jutify-content-around">
										<div v-for="(item,index) in scope.row.commitment_monthly" class="mx-1">
											<el-input v-model="scope.row.commitment_monthly[index].month_inst_arrears" disabled></el-input>	
										</div>
									</div>	
								</template>
            </el-table-column>
						<el-table-column
                prop="commitment_legal_status"
                width="80px"
                label="Lgl Sts"
								v-if="isfull"
            >
                <template slot="header" slot-scope="scope">
                    <span class="text-break">{{ scope.column.label }}</span>
                </template>
                <template slot-scope="scope">
                    <!-- <el-input v-model="scope.row.commitment_legal_status"></el-input> -->
                    {{ scope.row.commitment_legal_status }}
                </template>
            </el-table-column>
						<el-table-column
                prop="commitment_legal_date"
                width="120px"
                label="Date Sta. Updated"
								v-if="isfull"
            >
                <template slot="header" slot-scope="scope">
                    <span class="text-break">{{ scope.column.label }}</span>
                </template>
                <template slot-scope="scope">
                    <!-- <el-input v-model="scope.row.commitment_legal_date" type="date"></el-input> -->
										 {{ scope.row.commitment_legal_date }}
                </template>
            </el-table-column>

            <el-table-column label="Action">
                <template slot-scope="scope">
                    <el-button 
                        @click="deleteManualCommitment(scope.row.commitment_id,scope.$index)"
                        type="danger" 
                        icon="el-icon-close"
                        size="mini" 
                        circle
                        class="p-0"
                        v-if="scope.row.commitment_is_manual"
                        :disabled="(_gHlp.checkAccess(['role_telemarketing']))"
                    ></el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-button type="text" @click="addCommitment" v-if="(!_gHlp.checkAccess(['role_telemarketing']))" >+ Add Commitment</el-button>
        <div class="mt-3">
            <b-row class="d-flex justify-content-center">
                <b-col cols="6" md="3">
                    <el-button class="bg-primary text-white w-100" 
                        @click="saveManualCommitment" 
                        :loading="is_loading"
                        v-if="(!_gHlp.checkAccess(['role_telemarketing']))"
                    >Save
                    </el-button>
                </b-col>
            </b-row>
        </div>
    </div>
</template>
<script>
import { Button, Collapse, CollapseItem, Table, TableColumn, Input, Select, Option } from 'element-ui'
import { mapState, mapActions } from 'pinia'
import { useCustomerStore } from '@/stores/customerStore'
import { useCreditReportStore } from '@/stores/creditReportStore'
import {
    helperFunctionMixin,
    notifyFunctionMixin,
    axios,
    services,
    getHeader,
} from '@/assets/js/httpImports.js'
import {isEqual} from 'lodash'
import solutionEventBus from '@/assets/js/EventBus/solutionEventBus.js'
import {FIRT_MONTH_NAME} from '@/assets/js/options.js'
import { includes } from 'lodash'

export default {
    props: ['commitments', 'tables', 'isfull'],
    components: {
        [Button.name]: Button,
        [Collapse.name]: Collapse,
        [CollapseItem.name]: CollapseItem,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [Input.name]: Input,
        [Select.name]: Select,
        [Option.name]: Option,
    },
    mixins: [helperFunctionMixin, notifyFunctionMixin],
    data() {
        return {
            modals:{
                show_full_view: false
            },
            is_loading: false,
            tableData: [],
            original_ctos_commitments:[],
            original_ctos_manual_commitments:[],
						month_names:FIRT_MONTH_NAME,
						skipSummary:['commitment_legal_status','commitment_legal_date']
        }
    },
    computed:{
         ...mapState(useCustomerStore, ['current_customer', 'current_commitment'])
    },
    watch: {
        current_commitment(newVal){
            if(newVal){
                this.setTable()
            }
        },
    },
    async created(){
        this.setTable()
    },
    methods: {
        ...mapActions(useCustomerStore, ['generateDSR']),
        ...mapActions(useCreditReportStore, ['getCreditReportSummary']),
        addCommitment(){
            this.tableData.push({
                "commitment_credit_report_id": this.current_commitment ? this.current_commitment.credit_report_id : null,
                "commitment_cust_id": this.current_customer.customer_id,
                "commitment_cust_ic": this.current_customer.nric ? this.current_customer.nric : this.current_customer.passport,
                "commitment_is_special_attention": 0,
                "commitment_capacity": null,
                "commitment_approved_date": null,
                "commitment_lender_type": null,
                "commitment_loan_statue": null,
                "commitment_bank_id": null,
                "commitment_legal_status": null,
                "commitment_legal_name": null,
                "commitment_legal_date": null,
                "commitment_col_type": null,
                "commitment_repay_term": null,
                "commitment_status": null,
                "commitment_credit_limit": 0,
                "commitment_current_outstanding": 0,
                "commitment_current_installment": 0,
                "commitment_special_settlement": 0,
                "commitment_consolidate_settlement": 0,
                "commitment_new_installment": 0,
                "commitment_date_balance_updated": null,
                "commitment_position_date": null,
                "commitment_json_month": [],
                "commitment_is_manual": 1
            })
        },
        saveManualCommitment(){
            var axiosCalls = []
            var manual_commitments = this.tableData.filter(item => item.commitment_is_manual === 1)
            var ctos_commitments = this.tableData.filter(item => item.commitment_is_manual !== 1)

            this.is_loading = true

            manual_commitments.forEach((commitment) => {
                if(commitment.hasOwnProperty('commitment_id')){
                    // update existing manual commitment
                    const original_ctos_manual_commitment = this.original_ctos_manual_commitments.find(item => item.commitment_id === commitment.commitment_id)
                    if(!isEqual(original_ctos_manual_commitment, commitment)){
                        axiosCalls.push(this.updateManualCommitment(commitment.commitment_id, commitment))
                    }
                }else{
                    // create new manual commitment
                    axiosCalls.push(this.createManualCommitment(commitment))
                }
            })

            ctos_commitments.forEach((commitment) => {
                const original_ctos_commitment = this.original_ctos_commitments.find(item => item.commitment_id === commitment.commitment_id)
                if(!isEqual(original_ctos_commitment, commitment)){
                    axiosCalls.push(this.updateManualCommitment(commitment.commitment_id, commitment))
                }
            })

						Promise.all(axiosCalls)
                .then(async (res)  => {
                    this.notifySuccess('<b>Commitment </b> - Successfully Updated.')
										await this.getCreditReportSummary({credit_report_cust_id: this.current_customer.customer_id,recalculate_summary:true})
                    solutionEventBus.$emit('refresh-ctos');
										this.is_loading = false
                })
                .catch(e => {
                    this.is_loading = false
                    this.errorFunction(e, e.response.data.error)
                })
        },
        createManualCommitment(data){
            return axios.post(services.commitment +'manual-commitment', data, {headers: getHeader()});
        },
        updateManualCommitment(id, data){
            return axios.post(services.commitment +'manual-commitment/'+id, data, {headers: getHeader()});
        },
        deleteManualCommitment(id, index) {
            if(!id){
                this.tableData.splice(index, 1);
                return
            }

            axios.post(services.commitment +'manual-commitment/delete/'+id, null, {headers: getHeader()}).then(res  => {
                    this.notifySuccess('<b>Commitment </b> - Successfully Deleted.')
                    this.tableData.splice(index, 1);
                    this.generateDSR()
                })
                .catch(e => {
                    this.errorFunction(e, e.response.data.error)
                })
        },
        setTable(){
            this.tableData = []
            if(this.current_commitment){
                this.current_commitment.credit_report_summary.commitments.forEach(item => {
                    if(item.commitment_is_manual === 0){
                        item.commitment_sub_items.forEach(sub_item => {
                            this.tableData.push(sub_item)
                            this.original_ctos_commitments.push({...sub_item})
                        });
                    }else{
                        this.tableData.push(item)
                        this.original_ctos_manual_commitments.push({...item})
                    }
                });
            }
				},
        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = 'Summary';
                    return;
                }
                const values = data.map(item => {
									return (this.skipSummary.includes(column.property)) ? Number("X") : Number(item[column.property])
								});
                if (!values.every(value => isNaN(value))) {
                    const total = values.reduce((prev, curr) => {
                        const value = Number(curr);
                        if (!isNaN(value)) {
                            return prev + curr;
                        } else {
                            return prev;
                        }
                    }, 0);

                    sums[index] = 'RM ' + total.toLocaleString('en-MY', {minimumFractionDigits: 2});
                    } else {
                        sums[index] = '';
                    }
            });

            return sums;
        },
        handleDelete(index) {
            this.tableData.splice(index, 1);
        },
        formatCurrency(row, column, cellValue) {
            return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'MYR' }).format(cellValue);
        },
        formatCurrencyCard(value) {
            return `MYR ${parseFloat(value).toLocaleString(undefined, {minimumFractionDigits: 2})}`;
        },
    }
}
</script>


